import { render } from "./XERO.vue?vue&type=template&id=509820e6"
import script from "./XERO.vue?vue&type=script&lang=js"
export * from "./XERO.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/data-adapter/XERO.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "509820e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('509820e6', __exports__)) {
    api.reload('509820e6', __exports__)
  }
  
  module.hot.accept("./XERO.vue?vue&type=template&id=509820e6", () => {
    api.rerender('509820e6', render)
  })

}


export default __exports__